import { render, staticRenderFns } from "./TheCourseAssessment.vue?vue&type=template&id=7189660b&scoped=true&"
import script from "./TheCourseAssessment.vue?vue&type=script&lang=js&"
export * from "./TheCourseAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7189660b",
  null
  
)

export default component.exports